/**
 * Request methods
 * 
 * @version 1.0.0
 */
const RequestMethods = ( function () {

	/**
	 * -----------------------------------------------------------------------------
	 * Private EventLoader Helpers
	 * -----------------------------------------------------------------------------
	 */

	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	/**
	 * -----------------------------------------------------------------------------
	 * Public StringMethods API
	 * -----------------------------------------------------------------------------
	 */

	const Util = {

		auth: function ( url, query )
		{
			const BASE_URL = url + '?';
			const FETCH_STRING = query;
			let isJson = false;

			let myHeaders = new Headers({
				'X-Requested-With': 'PROMVC_XMLHttpRequest'
			});

			let init = {
				method: 'GET',
				headers: myHeaders,
				mode: 'cors',
				cache: 'default'
			};

			let myRequest = new Request( BASE_URL + FETCH_STRING, init );

			return (
				fetch( myRequest )
					.then(( response ) => {
						if ( response.ok ) {
							const reader = response.body.getReader();

							return new ReadableStream({
								start: function ( controller ) {
									return pump();
									function pump() {
										return (
											reader.read()
												.then( function ( chunk ) {
													const { done, value } = chunk;

													// When no more data needs to be consumed, close the stream
													if ( done ) {
														controller.close();
														return;
													}

													// Process chunk and determine type
													for ( let i = 0; i < 1; i++ ) {
														const char = String.fromCharCode( value[ i ] );
														if ( char === '{' || char === '[' ) {
															isJson = true;
														} 
													}

													// Enqueue the next data chunk into our target stream
													controller.enqueue( value );
													return pump();
												})
										);
									}
								}
							});
						}
					})
					.then( ( stream ) => {
						return new Response( stream );
					})
					.then(( response ) => {
						return isJson ? response.json() : response.text();
					})
					.catch(( error ) => {
						return error;
					})
			);
		}

	};

	return Util;

}());

// exports

export { RequestMethods };